import React, { useRef, useEffect, useState } from "react";
import landingImg from "../Assets/images/common/landing.png";
import { useNavigate } from "react-router-dom";

export default function HireHubLanding() {
   const currentUser = localStorage.getItem("candidate");
  const navigate = useNavigate();
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState("auto");

  useEffect(() => {
    function updateHeight() {
      if (window.innerWidth < 1024) {
        setContentHeight(365);
      } else if (contentRef.current) {
        setContentHeight(contentRef.current.offsetHeight);
      }
    }
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  return (
    <div className="w-full flex justify-center sm:h-full h-[90vh] overflow-auto">
      <div className="lg:flex block w-full">
        {/* LEFT SECTION */}
        <div
          ref={contentRef}
          className="lg:w-1/2 w-full lg:px-20 px-5 py-10 flex justify-center"
          style={{
            background:
              "linear-gradient(268deg, #EBF8FF -4.64%, #E7F1FF 101.98%)",
          }}
        >
          {/* 👇 This is the exact content height reference */}
          <div className="w-full max-w-xl space-y-6">
            <div
              onClick={() => {
                if (currentUser) {
                  localStorage.setItem("interview_type", "Candidate resume assessment");
                  navigate("/hirehub-role-picker");
                } else {
                  navigate("/login?type=Master Your Interview");
                }
              }}
              className="bg-white rounded-[10px] p-6 shadow-lg cursor-pointer hover:bg-[#033577] hover:text-white transition"
            >
              <h3 className="text-[22px] font-semibold mb-1">
                1. Master Your Interview
              </h3>
              <p className="text-[15px] font-medium">
                Prepare with AI. Perform with Confidence. Crack the Interview.
              </p>
            </div>

            <div
              onClick={() => {
                if (currentUser) {
                  localStorage.setItem("interview_type", "Big 5 - Personality Test");
                  navigate("/hirehub-talent");
                } else {
                  navigate("/login?type=AI Persona Check");
                }
              }}
              className="bg-white rounded-[10px] p-6 shadow-lg cursor-pointer hover:bg-[#033577] hover:text-white transition"
            >
              <h3 className="text-[22px] font-semibold mb-1">
                2. AI Persona Check
              </h3>
              <p className="text-[15px] font-medium">
                Understand Your Personality. Unlock Your Hidden Strengths
              </p>
            </div>

            <div
              // onClick={handleFocus}
              onClick={() => navigate("/jobs")}
              className="bg-white rounded-[10px] p-6 shadow-lg cursor-pointer hover:bg-[#033577] hover:text-white transition"
            >
              <h3 className="text-[22px] font-semibold mb-1">
                3. Find Your Job
              </h3>
              <p className="text-[15px] font-medium">
                <p>Precision - Driven Career Placement</p>
              </p>
            </div>

            {/* <div
              onClick={() =>
                (window.top.location.href =
                  "https://ipecsolutions.com/hiring-partners/")
              }
              // onClick={() =>
              //   window.open(
              //     `https://ipecsolutions.com/hiring-partners/`,
              //     "_self"
              //   )
              // }
              className="bg-white rounded-[10px] p-6 shadow-lg cursor-pointer hover:bg-[#033577] hover:text-white transition"
            >
              <h3 className="text-[22px] font-semibold mb-1">
                4. Hiring Partners
              </h3>
              <p className="text-[15px] font-medium">
                <p>
                  Corporates, Universities & Colleges: AI Interview integration
                  for better recruitment Process.
                </p>
                <p>Empower Candidates. Elevate Outcomes.</p>
              </p>
            </div> */}
          </div>
        </div>

        {/* RIGHT IMAGE — height sync applied 👇 */}
        <div
          className="flex lg:w-1/2 w-full h-[60vh]"
          // style={{
          //   height: contentHeight !== "auto" ? `${contentHeight}px` : "auto",
          // }}
        >
          <img
            src={landingImg}
            alt="Office"
            className="lg:w-[90%] w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
}
